/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ opened: NonNullable<unknown> }} Cases_Timeline_OpenedInputs */

const en_cases_timeline_opened = /** @type {(inputs: Cases_Timeline_OpenedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opened ${i?.opened}`)
};

const pt_br2_cases_timeline_opened = /** @type {(inputs: Cases_Timeline_OpenedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aberto em ${i?.opened}`)
};

/**
* | output |
* | --- |
* | "Opened {opened}" |
*
* @param {Cases_Timeline_OpenedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_timeline_opened = /** @type {((inputs: Cases_Timeline_OpenedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Timeline_OpenedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_timeline_opened(inputs)
	return pt_br2_cases_timeline_opened(inputs)
});